module.exports = __webpack_public_path__ + "media/images/flags/italy-334c534fc7361e29f506ad49876f8d74.jpg";